// extracted by mini-css-extract-plugin
export var conversationListItem = "_y8-2";
export var fullBleedList = "_y8-3";
export var messageText = "_y8-1";
export var previewText = "_y8-0";